export default {
  getAPI: state => {
    return state.apiurl
  },
  getMemberAPI: state => {
    return state.memberurl
  },
  getNews: state => {
    return state.news
  },
  getSlide: state => {
    return state.slide
  },
  getCompanies: state => {
    return state.companies
  },
  getAlliances: state => {
    return state.alliances
  },
  getUserID: state => {
    return state.userId
  },
  getUserName: state => {
    return state.userName
  },
  getUserPhone: state => {
    return state.userPhone
  },
  getUserCounty: state => {
    return state.userCounty
  },
  getUserDistrict: state => {
    return state.userDistrict
  },
  getUserAddress: state => {
    return state.userAddress
  },
  getUserEmail: state => {
    return state.userEmail
  },
  getUserCash: state => {
    return state.userCash
  },
  getToken: state => {
    return state.token
  },
  getUserValid: state => {
    return state.userValid
  },
  getCounty: state => {
    return state.county
  },
  getDistrict: state => {
    return state.district
  },
  getFirstbuy: state => {
    return state.firstbuy
  },
  getVolunteerQuota: state => {
    return state.volunteerQuota
  }
}



// WEBPACK FOOTER //
// ./src/store/home/getters.js